import { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import {
    makeAjax,
    url,
    respStatus,
    showMessage,
} from "../../../helpers/global_helper";
import { useSelector } from "react-redux";
import { gameLoadingContent } from "./gameLoadingContent";

const useHandleGameClick = (
    props,
    setIsCardLoading,
    setClickedGame,
    launchGameDetails
) => {
    const navigate = useNavigate();
    const [maintainanceError, setMaintainanceError] = useState(false);
    const [commingSoonPopup, setCommingSoonPopup] = useState(false);
    const [isgameplayerPopup, setIsGamePlayerPopup] = useState(false);
    const [gameLaunchMessage, setGameLaunchMessage] = useState(false);
    const [apiResponseError, setApiResponseError] = useState(false);
    const [userDataHandleClick, setUserDataHandleClick] = useState(false);
    const [loginforLunchLobby, setLoginforLunchLobby] = useState(false);
    const [gameId, setGameId] = useState("");
    const [togelGameBlock, setTogelGameBlock] = useState(false);
    const initAssetConfig = {
        width: 30,
        height: 30,
        alt: 'default alt',
        description: 'default description',
        image: '/assets/images/default-images/horasbet.png',
        link: '/'
    }
    const [assets, setAssets] = useState(initAssetConfig);
    const { otherMedia } = useSelector((state) => ({
        otherMedia: state.othermediaInformationListR.data,
    }));

    const { userProfile } = useSelector((state) => ({
        userProfile: state.playerProfileR?.data ?? {},
    }));
    const location = useLocation();
    // Global game window reference
    let gameWindowRef = null;

    useEffect(() => {
        const logoData = otherMedia?.['game_loader_icon']?.[0] || {};
        const updatedAssets = {
            ...initAssetConfig,
            width: logoData.width || initAssetConfig.width,
            height: logoData.height || initAssetConfig.height,
            description: logoData.description || initAssetConfig.description,
            alt: logoData.alternate || initAssetConfig.alt,
            image: logoData.path || initAssetConfig.image,
            link: logoData.link || initAssetConfig.link,
        };
        setAssets(updatedAssets);
    }, [otherMedia]);

    const handleGameClick = (game) => {
        const user_token = window.localStorage.getItem("user_token");
        if((!game?.tenant_provider_reco?.demo_active || game?.tenant_provider_reco?.demo_active === false) ||  (game?.is_demo === undefined || game?.is_demo === false)) {
            // if (!user_token && game?.provider?.url_slug !== "pragmatic-play" && game?.provider?.url_slug !== "spade-gaming") {
            //     navigate("/register");
            //     return;
            // }

            // const restrictProviders = ["pragmatic-play", "spade-gaming"];
            // const postIdProviders = ["slotsLobby", "LOBBYSPADEGAMING"];

            // if (!user_token && restrictProviders.includes(game?.provider?.url_slug) && postIdProviders.includes(game?.game_post_uid)) {
            //     navigate("/register");
            //     return;
            // }

        // Togel Game Block for Player
        if (userProfile.block_category == 'togel' && location.pathname == '/lottery') {
            setTogelGameBlock(true);
        }
        if (!user_token && game?.provider?.url_slug == "pragmatic-play" && game?.game_post_uid == "slotsLobby") {
            navigate("/register");
            return;
        }


        // Togel Game Block for Player
        if (
            userProfile.block_category == "togel" &&
            location.pathname == "/lottery"
        ) {
            setTogelGameBlock(true);
            return;
        }

    }
        // If game is on comming soon
        if (game.status === "Coming Soon") {
            setCommingSoonPopup(true);
            return;
        }

        // If game is under maintenance
        if (game.maintenance_mode) {
            setMaintainanceError(true);
            return;
        }

        setIsCardLoading(true);
        setClickedGame(game._id);
        setBodyStyles("none", "none");
        setGameId({ ...gameId, game_id: game._id });

        // #blank page loader text content
        gameWindowRef = window.open("", "_blank");
        if (gameWindowRef) {
            const html = gameLoadingContent(assets);
            gameWindowRef.document.open();
            gameWindowRef.document.write(html);
            gameWindowRef.document.close();
        }

        const payload = { game_id: game._id };

        makeAjax(url.GP_API.playerRedirection, payload, url.GP_MS_EXT)
            .then((response) => {
                if (response?.status !== respStatus["SUCCESS"]) {
                    makeAjax(url.GP_API.playerRedirection, payload, url.GP_MS_EXT)
                        .then((response) => {
                            if (response?.status !== respStatus["SUCCESS"]) {
                                if (response?.code === 'internal_err') {
                                    const tempMessage = `${props.t("oops")}! ${props.t("something_went_wrong")}. ${props.t("we_are_working_on_fixing_it")}. ${props.t("please_try_again_later")}.`;
                                    showMessage(tempMessage, 'playerRedirectionError');
                                } else if (response?.code === 'failed_system_error') {
                                    const tempMessage = `${props.t("wait_for_5_min_and_check_again")}.`;
                                    showMessage(tempMessage, 'playerRedirectionError');
                                } else if (response?.code === 'wait_5_min') {
                                    showMessage(response, 'playerRedirectionError');
                                } else if (response?.code === "game_under_maintenance") {
                                    setMaintainanceError(true);
                                } else if (response?.code === "game_not_active") {
                                    setCommingSoonPopup(true);
                                } else if (response?.code === "contact_operator") {
                                    setIsGamePlayerPopup(true);
                                }
                                else if (response?.code === "validation.invalid_token_error") {
                                    navigate("/register");
                                }
                                else if (response?.code === 'category_not_supported') {
                                    gameWindowRef.close();
                                    navigate("/register");
                                    return;
                                }
                                else if (response?.code !== "validation_error") {
                                    showMessage(response);
                                }
                                else if (response?.msg === 'api_down') {
                                    showMessage(response);
                                }
                            }

                            setMaintainanceError(false);
                            setApiResponseError(false);
                            resetBodyStyles();
                            setIsCardLoading(false);
                            setClickedGame(null);
                            if (response?.status === respStatus["SUCCESS"]) {
                                if (response?.data?.code === "bd200") {
                                    openGameTab(response?.data?.data, "pocket_game_soft", game, gameWindowRef);
                                } else {
                                    openGameTab(response.data, "games", game, gameWindowRef);
                                }
                                return;
                            }
                        })
                        .catch(() => {
                            showMessage("An error occurred. Please try again later.");
                            resetBodyStyles();
                            setIsCardLoading(false);
                            apiReponseGame();
                        });
                };
                const apiReponseGame = () => {
                    resetBodyStyles();
                    setClickedGame(null);
                    setApiResponseError(true);
                };

                const setBodyStyles = (cursor, pointerEvents) => {
                    document.body.style.cursor = cursor;
                    document.body.style.pointerEvents = pointerEvents;
                };

                const resetBodyStyles = () => {
                    setBodyStyles("", "");
                };

                // game lauch open tab function # added 1st august(12680)
                const openGameTab = (url, type, game, tabWindow) => {
                    setApiResponseError(false);
                    const uniqueId = Date.now().toString();
                    let newWindow = tabWindow || window.open(); // fallback just in case
                    let newUrl = url;
                    if (type === "pocket_game_soft") {
                        if (newWindow) {
                            newUrl = "pocket_game_soft";
                            newWindow.document.open();
                            newWindow.document.write(url); // Ensure `url` contains actual HTML content
                            newWindow.document.close();
                        }
                    } else {
                        newWindow.location.href = url; // redirect
                    }
                    Cookies.set("gameWindow", JSON.stringify({ id: uniqueId, url: newUrl, gameId: game._id }));
                    if (newWindow) {
                        newWindow.name = uniqueId;

                        const checkWindowClosed = setInterval(() => {
                            if (newWindow.closed) {
                                addUpdateOnlinePlayer({ game_id: game._id });
                                Cookies.remove("gameWindow");
                                Cookies.remove("gameObject");
                                clearInterval(checkWindowClosed);
                            }
                        }, 300);
                    }else {
                        Cookies.set("gameWindow", JSON.stringify({ id: uniqueId, url: null, gameId: game._id }));
                        if (newWindow) {
                            newWindow.name = uniqueId;
                            const checkWindowClosed = setInterval(() => {
                                if (newWindow.closed) {
                                    addUpdateOnlinePlayer({ game_id: game._id });
                                    Cookies.remove("gameWindow");
                                    Cookies.remove("gameObject");
                                    clearInterval(checkWindowClosed);
                                }
                            }, 300);
                        }
                    }
                }

                setMaintainanceError(false);
                setApiResponseError(false);
                resetBodyStyles();
                setIsCardLoading(false);
                setClickedGame(null);
                setTogelGameBlock(false);
                apiReponseGame();
                if (response?.status === respStatus["SUCCESS"]) {
                    if (response?.data?.code === "bd200") {
                        openGameTab(
                            response?.data?.data,
                            "pocket_game_soft",
                            game,
                            gameWindowRef
                        );
                    } else {
                        openGameTab(response.data, "games", game, gameWindowRef);
                    }
                    return;
                }else {
                    const uniqueId = Date.now().toString();
                    let newWindow = gameWindowRef || window.open(); 
                    Cookies.set("gameWindow", JSON.stringify({ id: uniqueId, url: null, gameId: game?._id }));
                    const checkWindowClosed = setInterval(() => {
                        if (newWindow.closed) {
                            addUpdateOnlinePlayer({ game_id: game._id });
                            Cookies.remove("gameWindow");
                            clearInterval(checkWindowClosed);
                        }
                    }, 300);
                }
            })
            .catch(() => {
                showMessage("An error occurred. Please try again later.");
                resetBodyStyles();
                setIsCardLoading(false);
                apiReponseGame();
            });
    };

    const addUpdateOnlinePlayer = (payload) => {
        makeAjax(url.USER_API.addUpdateOnlinePlayer,
            payload,
            url.USER_MS_EXT
        ).then((response) => {
            if (response.status != respStatus["SUCCESS"]) {
                if (response.code != "validation_error") {
                    showMessage(response);
                    return;
                }
                showMessage(response);
                return;
            }
        });
    };

    // Function to confirm relaunch
    const confirmRelaunch = () => {
        const gameWindowData = Cookies.get("gameWindow")
            ? JSON.parse(Cookies.get("gameWindow"))
            : null;
        let gameObject = Cookies.get("gameObject")
            ? JSON.parse(Cookies.get("gameObject"))
            : null;

        if (!gameObject) {
            ConfirmLanchGamePopup(launchGameDetails);
            setGameLaunchMessage(false);
            return;
        }

        // If same game is already launched
        if (gameId.game_id == gameObject._id) {
            window.open("", gameWindowData?.id);
        } else {
            const existingWindow = window.open("", gameWindowData?.id);
            if (existingWindow) {
                existingWindow.close();
            }
            handleGameClick(gameObject);
        }
        setGameLaunchMessage(false);
    };

    const cancelRelaunch = () => {
        Cookies.remove("gameObject");
        setGameLaunchMessage(false);
    };

    const apiReponseGame = () => {
        resetBodyStyles();
        setClickedGame(null);
        setApiResponseError(true);
    };

    const setBodyStyles = (cursor, pointerEvents) => {
        document.body.style.cursor = cursor;
        document.body.style.pointerEvents = pointerEvents;
    };

    const resetBodyStyles = () => {
        setBodyStyles("", "");
    };

    // Close maintaninace popup
    const handlePopup = () => {
        setMaintainanceError(false);
        setCommingSoonPopup(false);
        setLoginforLunchLobby(false);
        setGameLaunchMessage(false);
        setApiResponseError(false);
        setTogelGameBlock(false);
    };

    const userDataHandle = () => {
        setUserDataHandleClick(true);
    };

    const HandleGamePlayer = () => {
        setIsGamePlayerPopup(!isgameplayerPopup);
    };

    const ConfirmLanchGamePopup = (game) => {
        const gameWindowData = JSON.parse(Cookies.get("gameWindow") || "{}");

        // If a game tab is already open
        if (gameWindowData?.url && gameWindowData.url !== "0") {
            if (gameWindowData.gameId === game._id) {
                //if same game open
                window.open("", gameWindowData?.id);
                return;
            } else {
                Cookies.set("gameObject", JSON.stringify(game));
            }
            setGameLaunchMessage(true);
            return;
        }
        // For first-time game launch
        handleGameClick(game);
    };

    // game lauch open tab function # added 1st august(12680)
    const openGameTab = (url, type, game, tabWindow) => {
        setApiResponseError(false);
        const uniqueId = Date.now().toString();
        let newWindow = tabWindow || window.open(); // fallback just in case
        let newUrl = url;
        if (type === "pocket_game_soft") {
            if (newWindow) {
                newUrl = "pocket_game_soft";
                newWindow.document.open();
                newWindow.document.write(url); // Ensure `url` contains actual HTML content
                newWindow.document.close();
            }
        } else {
            newWindow.location.href = url; // redirect
        }

        Cookies.set(
            "gameWindow",
            JSON.stringify({ id: uniqueId, url: newUrl, gameId: game._id })
        );

        if (newWindow) {
            newWindow.name = uniqueId;

            const checkWindowClosed = setInterval(() => {
                if (newWindow.closed) {
                    Cookies.remove("gameWindow");
                    Cookies.remove("gameObject");
                    clearInterval(checkWindowClosed);
                }
            }, 300);
        }
        // For first-time game launch
        handleGameClick(game);
    };

    return {
        apiResponseError,
        maintainanceError,
        commingSoonPopup,
        isgameplayerPopup,
        gameLaunchMessage,
        handlePopup,
        userDataHandle,
        HandleGamePlayer,
        loginforLunchLobby,
        confirmRelaunch,
        cancelRelaunch,
        ConfirmLanchGamePopup,
        togelGameBlock,
    };
};

export default useHandleGameClick;
